import { useSelector } from 'react-redux';
import { useSessionTimeout } from '@dealstack/frontend/shared/components/SessionTimeout/useSessionTimeout';
import { SessionTimeoutWarningModal } from '@dealstack/frontend/shared/components/SessionTimeout/SessionTimeoutWarningModal';

/**
 * Subscribes to the store directly rather than taking the user state as a prop: the
 * components that render this one sit under a Suspense boundary and can hold a stale
 * redux snapshot, which left the countdown permanently disabled.
 */
interface SessionUserSlice {
	user: {
		isLoading: boolean;
		data: unknown | null;
	};
}

export const SessionTimeoutGuard = () => {
	const isSignedIn = useSelector(
		(state: SessionUserSlice) => !state.user.isLoading && Boolean(state.user.data)
	);
	const { isWarning, secondsRemaining, isExtending, extendSession, signOutNow } =
		useSessionTimeout({ enabled: isSignedIn });

	return (
		<SessionTimeoutWarningModal
			opened={isSignedIn && isWarning}
			secondsRemaining={secondsRemaining}
			isExtending={isExtending}
			onStaySignedIn={extendSession}
			onSignOut={signOutNow}
		/>
	);
};
